"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = nonNullable;
exports.useForm = useForm;

var _react = require("react");

var _FormValue = require("./FormValue");

function nonNullable(value) {
  return value !== null && value !== undefined;
}

const meta = {};

function validate(value, validators) {
  if (!validators) {
    return [];
  }

  if (Array.isArray(validators)) {
    return validators.map(validator => {
      if (typeof validator === "function") {
        const res = validator(meta, value);
        return res;
      }
    }).filter(nonNullable);
  }

  if (Array.isArray(value)) {
    const each = validators.each;
    const formListErrors = {
      all: Array.isArray(validators.all) ? validators.all.map(validator => validator(meta, value)) : undefined,
      each: each ? value.map(item => validate(item, each)) : undefined
    };
    return formListErrors;
  }

  if (typeof value === "object" && typeof validators === "object") {
    const result = {};
    Object.keys(validators).forEach(key => {
      const subValidators = validators[key];
      result[key] = validate(value[key], subValidators);
    });
    return result;
  }

  return [];
}

function useForm(_, initial, validator = null) {
  const [value, change] = (0, _react.useState)(initial);
  const [touched, setTouched] = (0, _react.useState)(null);
  const [showErrors, setShowErrors] = (0, _react.useState)(false);
  return new _FormValue.FormValue(value, newValue => change(newValue), touched, setTouched, validate(value, validator), showErrors, setShowErrors);
}
//# sourceMappingURL=useForm.js.map